import { Component, OnInit } from "@angular/core";
import { LocationService } from "./location.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
    MenuItems,
    Status,
    Answer,
    Severity,
    ObjectNames,
} from "../constants/constants";
import { ConfirmationService, MessageService } from "primeng/api";
import { AppMainComponent } from "src/app/app.main.component";
import { TitleCasePipe } from "@angular/common";
import { LocationFieldsService } from "./location-fields/location-fields.service";
import { AddYearPipe } from "src/app/shared/pipes/add-year.pipe";
import { addInList } from "src/app/modules/shared/helpers";
import { SubscriptionFeatureLimitM } from "src/app/modules/shared/models/organization-subscription/subscription-feature-limit.modal";
import { FeatureSubscriptionInfoEnums } from "src/app/modules/shared/enums/feature-subscription-info.enum";
import { OrganizationSubscriptionService } from "src/app/modules/shared/services/organization-subscription.service";
import { AppMainService } from "src/app/app-main.service";

@Component({
    selector: "app-location",
    templateUrl: "./location.component.html",
    styleUrls: ["./location.component.scss"],
})
export class LocationComponent implements OnInit {
    locationForm: FormGroup;
    addNewOptionForm: FormGroup;
    configMenuLocationItems = [];
    allLocations = [];
    statusConstants = Status;
    answertypeConstants = Answer;
    group;
    categoryGroup;
    groups = [];
    inventoryGroups = [];
    allContactsDD = [];
    types = [];
    category = [];
    country = [];
    states = [];
    city = [];
    addressTypes = [];
    addressInput: string = "";
    formattedAddress="";
    streetAddress2: string = "";
    selectedCountry;
    selectedState;
    selectedCity;
    zipCode;
    ErrorMessageSetLocation: string = "";
    displayAddEditLocation: boolean = false;
    locationHeader: string;
    isAddLocation: boolean = false;
    addEditOptionHeader: string;
    invalidGroupData: boolean = false;
    displayAddNewOption: boolean = false;
    statusDisabled: boolean = false;
    invalidData: boolean = false;
    index: number = 0;
    lattitude = 0;
    longitude = 0;
    savedLocation;
    associatedProducts: string='';
    displayLocationAvailability: boolean=false;
    duplicateItem: boolean=false;

    subscriptionLimit: SubscriptionFeatureLimitM = null;
    
    constructor(
        private locationService: LocationService,
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private titlecasePipe: TitleCasePipe,
        private fb: FormBuilder,
        private app: AppMainComponent,
        private fieldService: LocationFieldsService,
        private addYear: AddYearPipe, private appMainService: AppMainService,
        private organizationSubscriptionService: OrganizationSubscriptionService
    ) {}

    ngOnInit(): void {
        this.fieldService.getCategory().subscribe((cat) => {
            this.getLocationGroup();
        });
        this.checkSubscriptionLimit();
        this.locationForm = this.fb.group({
            id: [0],
            organizationId: [""],
            locationId: [
                "",
                [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
            ],
            address: [""],
            name: [
                "",
                [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
            ],
            description: [""],
            addressId: [0],
            userId: [0],
            phoneNo: [""],
            emailId: [""],
            isDefault: [false],
            parentWarehouseId: [0],
            groupId: [""],
            typeId: [""],
            categoryId: [0],
            statusId: [true],
            warehouseProduct: [""],
            warehouseCategory: [""],
        });

        this.addNewOptionForm = this.fb.group({
            id: [0],
            createdSource: [""],
            updatedSource: [""],
            createdBy: [""],
            updatedBy: [""],
            createdDate: [""],
            updatedDate: [""],
            name: ["",[Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
            parentGroupId: [0],
            groupOrganization: [
                {
                    id: [0],
                    createdSource: [""],
                    updatedSource: [""],
                    createdBy: [""],
                    updatedBy: [""],
                    createdDate: [""],
                    updatedDate: [""],
                    groupId: [0],
                    organizationId: [this.app.companyId],
                    statusId: [Status.ACTIVE],
                },
            ],
            description: [""],
            isValid: [true],
            validFromDate: [""],
            validToDate: [""],
        });
        this.configMenuLocationItems = [
            {
                label: MenuItems.Location,
                icon: "pi pi-plus",
                command: () => {
                    this.showAddLocation();
                },
            },
            {
                label: MenuItems.Bin,
                icon: "pi pi-plus",
                command: () => {
                    this.showAddBinDetails();
                },
            },
            // {
            //     label: MenuItems.LocationField,
            //     icon: "pi pi-plus",
            //     command: () => {
            //         this.showAddCategoryData();
            //     },
            // },
        ];
        this.loadLocations();
        this.getAllCountry();
        this.getAllAddressTypes();
    }

    getIndex(event) {
        this.index = event.index;
    }

    checkSubscriptionLimit(){
        this.organizationSubscriptionService
        .getFeatureSubscriptionInfo(FeatureSubscriptionInfoEnums.Location).subscribe({
            next: (response)=>{
                this.subscriptionLimit = response;
            }
        })
    }

    get subscriptionLimitReached(){
        return (this.isAddLocation
        && this.subscriptionLimit?.allowedLicence
        && this.subscriptionLimit?.allowedLicence<=this.subscriptionLimit?.consumedLicense)
    }

    get addressMandatory(){
        return (this.addressInput && this.selectedCountry && this.selectedState && this.selectedCity)
    }

    showAddLocation() {
        this.locationHeader = ObjectNames.locationConstants.AddLocationTitle;
        this.duplicateItem =false;
        this.displayAddEditLocation = true;
        this.invalidData = false;
        this.statusDisabled = false;
        this.isAddLocation = true;
        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.zipCode = "";
        this.lattitude = 0;
        this.longitude = 0;
        this.addressInput=null;
        this.locationForm = this.fb.group({
            id: [0],
            organizationId: [this.app.companyId],
            locationId: [
                "",
                [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
            ],
            address: [""],
            name: [
                "",
                [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
            ],
            description: [""],
            addressId: [0],
            userId: [0],
            phoneNo: [""],
            emailId: [""],
            isDefault: [false],
            parentWarehouseId: [0],
            groupId: [
                this.groups.filter((g) => g.createdSource == "system")[0],
            ],
            typeId: [this.types[0]],
            categoryId: [0],
            statusId: [true],
            warehouseProduct: [""],
            warehouseCategory: [this.category],
        });
    }

    filterContact(event,action?) {
        const query = event?.query ?? event;
        this.locationService.getAttnContactLost(query?.toLowerCase()).subscribe((res: any) => {
            if (res?.length > 0) {
                this.allContactsDD = res.filter((r) => r.statusId == Status.ACTIVE);
                if(action){
                    this.locationForm.controls['userId'].setValue(this.allContactsDD[0])
                }
            }
        });
    }

    clearContact(event){
      this.locationForm.controls['userId'].setValue(0);
    }

    showAddCategoryData() {
        this.index = 2;
        this.locationService.setCategory(ObjectNames.BehaviorSubjectVariable);
    }

    showAddBinDetails() {
        this.index = 1;
        this.locationService.setBin(ObjectNames.BehaviorSubjectVariable);
    }

    getLocationGroup() {
        this.locationService.getAllGroups().subscribe((groups) => {
            this.inventoryGroups = groups;
            const typeGroup = groups.filter(
                (group) =>
                    group.name == ObjectNames.locationConstants.typeGroupName
            )[0];
            this.getAllLocationTypes(typeGroup.id);
            this.group = groups.filter(
                (group) => group.name == ObjectNames.locationConstants.groupName
            )[0];
            this.getAllLocationGroups(this.group.id);
            this.categoryGroup = groups.filter(
                (group) =>
                    group.name ==
                    ObjectNames.locationConstants.categoryGroupName
            )[0];
            this.getAllLocationCategory(this.categoryGroup.id);
        });
    }

    getAllLocationTypes(groupId) {
        this.locationService.getAllGroupTypes(groupId).subscribe((types) => {
            this.types = types;
            this.locationForm.controls["typeId"].setValue(this.types[0]);
        });
    }

    getAllAddressTypes() {
        this.locationService.getAddressTypes().subscribe((types) => {
            this.addressTypes = types;
        });
    }

    getAllCountry() {
        this.locationService.getCountry().subscribe((country) => {
            this.country = country;
        });
    }

    getStatesFromCountry(country) {
        const countryID = country.id;
        this.locationService.getAllStates(countryID).then((states) => {
            this.states = states;
        });
    }

    getCitiesFromState(state) {
        this.locationService.getAllCities(state.id).then((cities) => {
            this.city = cities;
        });
    }

    removeAddressLocation() {
        this.addressInput = "";
        this.streetAddress2 = "";
        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.zipCode = "";
    }

    getAddressObj(address) {
        const addressObj = {
            street_number: null,
            subpremise: null,
            plus_code: null,
            neighborhood: null,
            landmark: null,
            route: null,
            sublocality_level_3: null,
            sublocality_level_2: null,
            sublocality_level_1: null,
            locality: null,
            city: null,
            state: null,
            country: null,
            zipCode: null,
            latitude: address.geometry.location.lat(),
            longitude: address.geometry.location.lng(),
        }
        address.address_components.forEach(comp => {
            const field = comp.types[0];
            if (field == 'street_number') {
                addressObj.street_number = comp;
            }
            if (field == 'plus_code') {
                addressObj.plus_code = comp;
            }
            if (field == 'neighborhood') {
                addressObj.neighborhood = comp;
            }
            if (field == 'landmark') {
                addressObj.landmark = comp;
            }
            if (field == 'route') {
                addressObj.route = comp;
            }
            if (field == 'sublocality_level_3') {
                addressObj.sublocality_level_3 = comp;
            }
            if (field == 'sublocality_level_2') {
                addressObj.sublocality_level_2 = comp;
            }
            if (field == 'sublocality_level_1') {
                addressObj.sublocality_level_1 = comp;
            }
            if (field == 'subpremise'){
                addressObj.subpremise = comp;
            }
            // city
            if (field == 'locality') {
                addressObj.locality = comp;
                addressObj.city = comp;
            }
            // // city
            // if(field =='administrative_area_level_2'){
            //     addressObj.city = comp;
            // }
            // state
            if (field == 'administrative_area_level_1') {
                addressObj.state = comp;
            }
      
            if (field == 'country') {
                addressObj.country = comp;
            }
            if (field == 'postal_code') {
                addressObj.zipCode = comp;
            }
        });
        if (addressObj.city == null) {
            addressObj.city = addressObj.sublocality_level_1;
        }
        return addressObj;
      }
      
      getStreetAddres(googleAddressObj) {
        const street = [];
        if (googleAddressObj.plus_code) {
            street.push(googleAddressObj.plus_code.long_name);
        }
        if (googleAddressObj.street_number) {
            street.push(googleAddressObj.street_number.long_name);
        }
        if (googleAddressObj.route) {
            street.push(googleAddressObj.route.long_name);
        }
        if (googleAddressObj.subpremise) {
            street.push(`#${googleAddressObj.subpremise.long_name}`);
        }
        if(googleAddressObj.neighborhood){
            street.push(googleAddressObj.neighborhood.long_name);
        }
        if(googleAddressObj.sublocality_level_3){
            street.push(googleAddressObj.sublocality_level_3.long_name);
        }
        if(googleAddressObj.sublocality_level_2){
            street.push(googleAddressObj.sublocality_level_2.long_name);
        }
        if(googleAddressObj.sublocality_level_1 && googleAddressObj.locality != null){
            street.push(googleAddressObj.sublocality_level_1.long_name);
        }
        // if(googleAddressObj.locality){
        //     street.push(googleAddressObj.locality.long_name);
        // }
        return street.length ? street.join(' ') : '';
      }

      async addCity(searchedCityName, stateId) {
        const data = {
            "id": 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": null,
            "createdBy": this.app.user.userId,
            "updatedBy": 0,
            "createdDate": new Date(),
            "updatedDate": null,
            "name": searchedCityName,
            "description": searchedCityName,
            "stateId": stateId,
            "statusId": 1,
        }
        //console.log('new city data', data)
        //this.appMainService.isShowSpinner('addNewCity');
        const newAddedCity = await this.locationService.addCity(data)
        //console.log('added city', newAddedCity)
        this.city = addInList(this.city, newAddedCity);
        //this.appMainService.isHideSpinner('addNewCity');
        return newAddedCity;
      }
      
      
      async addState(stateDetails, countryId) {
        const data = {
            id: 0,
            "createdSource": this.app.user.userIP,
            "updatedSource": null,
            "createdBy": this.app.user.userId,
            "updatedBy": 0,
            "createdDate": new Date(),
            "updatedDate": null,
            "name": stateDetails.long_name,
            "shortName": stateDetails.short_name,
            "description": stateDetails.long_name,
            "countryId": countryId,
            "statusId": 1,
        }
        const newAddedState = await this.locationService.addState(data);
        this.states = addInList(this.states, newAddedState);
        return newAddedState;
      }

    async locationAddresChanged(address: any) {
        this.removeAddressLocation();
        //setting address from API to local variable
        this.ErrorMessageSetLocation = "";

        //var fullAddress = address.address_components;
        this.formattedAddress = address.formatted_address;
        const googleAddressObj = this.getAddressObj(address);
        // const addressArr = address.formatted_address.split(",");
        // const len = addressArr.length;
        // const addressName = len > 2 ? addressArr.slice(0, len - 3).join() : "";
        setTimeout(() => {
            const da = this.getStreetAddres(googleAddressObj); //updatedAddressLine;
            this.addressInput = da;
        });

        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.zipCode = "";
        this.lattitude = googleAddressObj.latitude;
        this.longitude = googleAddressObj.latitude;

        // let searchedCountry =
        //     len > 1 && addressArr[len - 1] ? addressArr[len - 1].trim() : "";
        // const stateArr = len > 1 && addressArr[len - 2].trim().split(" ");
        // const searchedZipcodeData =
        //     stateArr.length > 1 ? stateArr[stateArr.length - 1].trim() : "";
        // const searchedZipcode = !isNaN(searchedZipcodeData)
        //     ? searchedZipcodeData
        //     : null;
        // const searchedState = searchedZipcode
        //     ? stateArr
        //           .slice(0, stateArr.length - 1)
        //           .join(" ")
        //           .trim()
        //     : stateArr.join(" ");
        // const searchedCity =
        //     len > 1 && addressArr[len - 3] ? addressArr[len - 3].trim() : "";
        // let stretAdd1 = addressArr[len - 4] ? addressArr[len - 4].trim() : "";
        // if (addressArr[len - 5]) {
        //     stretAdd1 = `${addressArr.slice(0, len - 3).join()}`;
        // }

        let searchedCountry = googleAddressObj.country ? googleAddressObj.country.long_name : '';
        let searchedZipcode = googleAddressObj.zipCode ? googleAddressObj.zipCode.long_name : '';
        let searchedState = googleAddressObj.state ? googleAddressObj.state.long_name : '';
        let searchedCity = googleAddressObj.city ? googleAddressObj.city.long_name : '';
        if (searchedCountry) {
          let matchedCountry;
          if (searchedCountry == 'USA' || searchedCountry == 'United States') {
            matchedCountry = this.country.find(obj => obj.name == searchedCountry || obj.countryCode == googleAddressObj.country.short_name);
           } else {
            matchedCountry = this.country.find(obj => obj.name == searchedCountry)
           }

            if (matchedCountry) {
                await this.getAsyncStatesFromCountry(matchedCountry);
                this.selectedCountry = matchedCountry;

                //set state
                let matchedState = this.states.find(obj => obj.name == searchedState || obj.shortName == googleAddressObj.state.short_name);
                if (matchedState) {
                    //await this.getAsyncCitiesFromState(matchedState);
                    this.selectedState = matchedState;
                }else if(!matchedState){
                    // add state
                    matchedState = await this.addState(googleAddressObj.state, matchedCountry.id);
                    this.selectedState = matchedState;
                  }
    
                   await this.getAsyncCitiesFromState(matchedState);

                if (searchedZipcode) {
                    this.zipCode = searchedZipcode;
                }
                //set city
                let matchedCity = this.city.find(
                    (obj) => obj.name == searchedCity
                );
                if (matchedCity) {
                    this.selectedCity = matchedCity;
                }else if(!matchedCity){
                    matchedCity = await this.addCity(searchedCity, matchedState.id);
                    this.selectedCity=matchedCity;
                  }
            }
        }
    }

    async getAsyncStatesFromCountry(country) {
        let countryID = country.id;
        await this.locationService.getAllStates(countryID).then((states) => {
            this.states = states;
            this.selectedState = null;
        });
    }

    async getAsyncCitiesFromState(state) {
        await this.locationService.getAllCities(state.id).then((cities) => {
            this.city = cities;
            this.selectedCity = null;
        });
    }

    getAllLocationCategory(groupId) {
        this.locationService.getAllCategory(groupId).subscribe((category) => {
            this.category = category;
        });
    }

    getAllLocationGroups(groupId) {
        this.locationService.getAllGroups(groupId).subscribe((types) => {
            this.groups = types;
            this.locationForm.controls["groupId"].setValue(this.groups[0]);
        });
    }

    locationDefault(location) {
        if(location.address){
            location.address.state=null;
            location.address.city=null;
            location.address.country=null;
        }
        this.updateDefaultLocation(location.id)
        // this.updateLocation(location);
    }

    updateDefaultLocation(id) {
        this.locationService.updateDefaultLocation(id).subscribe(resp => {
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titlecasePipe.transform(Severity.Success),
                    detail: "Location Updated successfully...",
                });
                this.loadLocations();
        })
    
    }
        loadLocations() {
            this.appMainService.isShowSpinner('allLocations');
            this.locationService.getLocationList().subscribe((locations) => {
            this.appMainService.isHideSpinner('allLocations');
                if(locations){
                    this.allLocations = locations;
                }
            });
        }

    async showEditLocation(location) {
        this.savedLocation = location;
        this.duplicateItem =false;
        this.selectedCountry = null;
        this.selectedState = null;
        this.selectedCity = null;
        this.zipCode = "";
        this.lattitude = 0;
        this.longitude = 0;
        this.addressInput='';
        if(location.address?.country){
          await this.getAsyncStatesFromCountry(location.address?.country);
        }
        if(location.address?.state){
          await this.getAsyncCitiesFromState(location.address?.state);
        }
        this.statusDisabled = false;
        this.locationHeader = ObjectNames.locationConstants.EditLocationTitle;
        this.displayAddEditLocation = true;
        this.invalidData = false;
        this.isAddLocation = false;
        if (location.isDefault) {
            this.statusDisabled = true;
        }
        this.locationForm.patchValue(location);
        if(location.contactPersonName){
            this.filterContact(location.contactPersonName,true);  
        }
        this.locationForm.controls["statusId"].setValue(
            location.statusId == Status.ACTIVE ? true : false
        );
        const filteredType = this.types.filter(
            (type) => type.id == location.typeId
        )[0];
        this.locationForm.controls["typeId"].setValue(filteredType);
        const filteredGroup = this.groups.filter(
            (group) => group.id == location.groupId
        )[0];
        this.locationForm.controls["groupId"].setValue(filteredGroup);
        const array = [];
        location.warehouseCategory.forEach((element) => {
            const filter = this.category.filter(
                (cat) => cat.id == element.categoryId
            );
            if (filter.length > 0) {
                array.push(filter[0]);
            }
        });
        this.locationForm.controls["warehouseCategory"].setValue(array);
        this.addressInput = location.address?.streetAddress1;
        this.streetAddress2 = location.address?.streetAddress2;
        const filteredCountry = this.country?.filter(c=> c.id==location.address?.countryId)[0];
        this.selectedCountry= filteredCountry;
        const filteredState = this.states?.filter(c=> c.id==location.address?.stateId)[0];
        this.selectedState= filteredState;
        const filteredCity = this.city?.filter(c=> c.id==location.address?.cityId)[0];
        this.selectedCity= filteredCity;
        this.zipCode= location.address?.zipCode;
    }

    checkWarehouseStatus(){
        if(!this.isAddLocation && !this.locationForm.controls['statusId'].value){
          this.locationService.getWarehouseStatus(this.locationForm.controls['id'].value).subscribe(status=>{
            if(status.item1){
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: `${status.item2}`,
                });
                this.locationForm.controls['statusId'].setValue(true);
            }
          })
        }
    }

    checkDeleteWarehouse(location){
        this.locationService.getWarehouseStatus(location.id).subscribe(status=>{
            if(status.item1 && status.item2!=""){
                this.displayLocationAvailability=true;
                this.associatedProducts=status.item2;
              }else if(status.item1 && status.item2==""){
               this.displayLocationAvailability=true;
               this.associatedProducts=status.item2;
              }else{
                  this.deleteLocation(location);
              }
        })
    }

    deleteLocation(location) {
        this.confirmationService.confirm({
            message: "Do you want to delete this Location?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.locationService
                    .deleteLocation(location.id)
                    .then(() => {
                        this.messageService.add({
                            severity: Severity.Success,
                            summary: this.titlecasePipe.transform(
                                Severity.Success
                            ),
                            detail: "Deleted Successfully...",
                        });
                        const index = this.allLocations.indexOf(location);
                        this.allLocations.splice(index, 1);
                    })
                    .catch(() => {
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(
                                Severity.Error
                            ),
                            detail: "Error occurred while deleting data...",
                        });
                    });
            },
            reject: () => {},
        });
    }

    checkDuplicateLocationId(){
        const locId = (!this.isAddLocation? this.savedLocation.id:0);
        const locationId = this.locationForm.controls['locationId'].value;
        if(locationId){
         this.locationService.checkIsDuplicateLocation(locationId,locId).subscribe(check=>{
             if(check){
              this.duplicateItem = true;
             }else{
              this.duplicateItem = false;
             }
         })
        }
     }

    saveLocation(value) {
        value.statusId = value.statusId ? Status.ACTIVE : Status.INACTIVE;
        value.groupId = value.groupId?.id ?? 0;
        value.typeId = value.typeId?.id ?? 0;
        value.userId = value.userId?.id ?? 0;
        const categoryArray = [];
        value.warehouseCategory.forEach((element) => {
            const req = {
                id: 0,
                warehouseId: value.id ? value.id : 0,
                statusId: Status.ACTIVE,
                categoryId: element.id,
            };
            categoryArray.push(req);
        });
        value.warehouseCategory = [];
        value.warehouseCategory = categoryArray;
        const address = {
            id: (this.savedLocation?.addressId>0?this.savedLocation?.addressId:0),
            name: this.addressInput,
            streetAddress1: this.addressInput,
            streetAddress2: this.streetAddress2,
            description: "",
            latitude: this.lattitude,
            longitude: this.longitude,
            cityId: (this.selectedCity?this.selectedCity.id:null),
            city: null,
            stateId: (this.selectedState?this.selectedState.id:null),
            state: null,
            countryId: (this.selectedCountry?this.selectedCountry.id:null),
            country: null,
            zipCode: this.zipCode,
            addressTypeId: this.addressTypes.filter(
                (a) => a.name == "Billing"
            )[0]?.id,
            statusId: Status.ACTIVE,
        };
        value.address = address;

        if (this.isAddLocation) {
            const lowerCaseNames = [];
            for (let s of this.allLocations) {
                lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ""));
            }
            if (
                lowerCaseNames.indexOf(
                    value.name.toLowerCase().replace(/ /g, "")
                ) > -1
            ) {
                this.invalidData = true;
            } else {
                this.locationService
                    .addLocation(value)
                    .then(() => {
                        this.messageService.add({
                            severity: Severity.Success,
                            summary: this.titlecasePipe.transform(
                                Severity.Success
                            ),
                            detail: "Location Added successfully...",
                        });
                        this.loadLocations();
                        this.displayAddEditLocation = false;
                    })
                    .catch(() => {
                        this.displayAddEditLocation = false;
                        this.messageService.add({
                            severity: Severity.Error,
                            summary: this.titlecasePipe.transform(
                                Severity.Error
                            ),
                            detail: "Error occurred while saving data...",
                        });
                    });
            }
        } else {
            const duplicateRecord = this.allLocations.find(
                (depOb) =>
                    depOb.name.toLowerCase() == value.name.toLowerCase() &&
                    depOb.id !== value.id
            );
            if (duplicateRecord) {
                this.invalidData = true;
            } else {
                this.invalidData = false;
                this.updateLocation(value);
            }
        }
    }

    updateLocation(value) {
        this.locationService
            .updateLocation(value)
            .then(() => {
                this.messageService.add({
                    severity: Severity.Success,
                    summary: this.titlecasePipe.transform(Severity.Success),
                    detail: "Location Updated successfully...",
                });
                this.loadLocations();
                this.displayAddEditLocation = false;
            })
            .catch(() => {
                this.displayAddEditLocation = false;
                this.messageService.add({
                    severity: Severity.Error,
                    summary: this.titlecasePipe.transform(Severity.Error),
                    detail: "Error occurred while saving data...",
                });
            });
    }

    addNewOption(value) {
        this.addEditOptionHeader = ObjectNames.locationConstants.AddGroupTitle;
        this.invalidGroupData = false;
        if (value.groupId.name == ObjectNames.locationConstants.AddGroupTitle) {
            this.addNewOptionForm = this.fb.group({
                id: [0],
                createdSource: [this.app.userIP],
                updatedSource: [this.app.userIP],
                createdBy: [this.app.userId],
                updatedBy: [this.app.userId],
                createdDate: [new Date().toISOString()],
                updatedDate: [new Date().toISOString()],
                name: [
                    "",
                    [Validators.required, Validators.pattern(/^(?!\s*$).+/)],
                ],
                parentGroupId: [this.group.id],
                groupOrganization: [
                    {
                        id: 0,
                        createdSource: this.app.userIP,
                        updatedSource: this.app.userIP,
                        createdBy: this.app.userId,
                        updatedBy: this.app.userId,
                        createdDate: new Date().toISOString(),
                        updatedDate: new Date().toISOString(),
                        groupId: 0,
                        organizationId: this.app.companyId,
                        statusId: Status.ACTIVE,
                    },
                ],
                description: [""],
                isValid: [true],
                validFromDate: [new Date().toISOString()],
                validToDate: [this.addYear.transform(new Date())],
            });

            this.displayAddNewOption = true;
        }
    }

    saveGroup(value) {
        value.description = value.name;
        const lowerCaseNames = [];
        for (let s of this.groups) {
            lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ""));
        }
        if (
            lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, "")) >
            -1
        ) {
            this.invalidGroupData = true;
        } else {
            this.locationService
                .addLocationGroup(value)
                .then(() => {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Group Added successfully...",
                    });
                    this.getLocationGroup();
                    this.displayAddNewOption = false;
                })
                .catch(() => {
                    this.displayAddNewOption = false;
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred while saving data...",
                    });
                });
        }
    }
}
